import React, { Component } from "react";
import {
  Box,Tabs,Tab,Grid,Card,CardContent,Table,TableBody,TableCell,TableContainer,TableHead,TableRow,Paper,Button,Collapse,CircularProgress,
  Typography,LinearProgress,Accordion,AccordionSummary,AccordionDetails, FormControl, Select, MenuItem,  InputLabel  } from "@mui/material";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import urls from "../../custom_libraries/urls";
import { get } from "../../custom_libraries/serverRequests";
import globalVariables from "../../custom_libraries/globalVariables";
import DnsIcon from "@mui/icons-material/Dns";  // Represents a "server" symbol
import StorageIcon from "@mui/icons-material/Storage";
import TimelineIcon from "@mui/icons-material/Timeline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SpeedIcon from "@mui/icons-material/Speed";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CastIcon from '@mui/icons-material/Cast';
import EmergencyRecordingIcon from '@mui/icons-material/EmergencyRecording';
// import {} from "@mui/material";

//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#191e29",
      paper: "#212632",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------

class CapacityDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSubTab: 0,
      expandedRow: null,
      loading: false,
      total_capacity: 0,
      total_used: 0,
      total_available: 0,
      utilization_percent: 0,
      servers: [],
      users: [],
      cameraDistribution: [],
      selectedServer: null,
      selectedServerCameras: [],
      cameraStatusSummary: null,
      onlineIds: [],
      offlineIds: [],
      initializingIds: [],
      statusLoading: false,
      openServerRow: null,
      sessionDuration: "0m 0s",
      filterDays: 7, // default
      showOfflineList: false,     // <– when true: show offline list instead of server list
      offlinePage: 1,
      offlineCount: 0,
      offlineRecords: [],
      offlineLoading: false,
      showOnlineList: false,
      onlineRecords: [],
      serverWiseCameras: [],
      serverWisePage: 1,
      serverWiseNext: null,
      serverWisePrev: null,
      showInitializingList: false,
      initializingRecords: [],
      initializingLoading: false,
      lowFpsCameras: [],
      showLowFpsList: false,
      lowFpsLoading: false,
      lowFpsThreshold: 6,
      showServerDropdown: true,
      showServerOfflineMessage: false,
      showNoCamerasMessage: false,
      selectedCameraCard: 'online',
      open_progress_bar: false,
      unmuted_cameras_count: null,

    };
  }

  componentDidMount() {
    // 🔐 Store server username/password (Basic Auth)
  localStorage.setItem(globalVariables.SERVER_CAPACITY_USERNAME, "admin");
  localStorage.setItem(globalVariables.SERVER_CAPACITY_PASSWORD, "neudeep@1");

   // 1️⃣ First fetch servers
 this.fetchServerCapacity().then(() => {
  if (this.state.servers.length > 0) {

    // 1️⃣ Pick first ONLINE server
    const onlineServer = this.state.servers.find(s => s.is_online);

    // 2️⃣ If no online server → select the first server
    const defaultServer = onlineServer
      ? onlineServer.server_id
      : this.state.servers[0].server_id;

    console.log("Auto-selected server:", defaultServer);

    this.setState({ selectedServer: defaultServer, loading: true });

    // Load server-wise camera list
    this.fetchServerCameraList(defaultServer, 1);
  }
});
    this.fetchDashboardData();
    this.startSessionTimer();
    this.fetchLowFpsCameras(3);
    this.fetchUnmutedCamerasCount()

  }

fetchCameraNames = async () => {
  try {
    let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);

    const response = await fetch(urls.CAMERAS_STATUS_INCLUDE_DETAILS, {
      method: "GET",
      headers: {
        "content-type": "application/json",
        "Authorization": `Bearer ${access_token}`,
      }
    });

    const data = await response.json();

    this.setState({
      sitesFromAPI: data.sites || []
    });

  } catch (err) {
    console.error("Error fetching camera names:", err);
  }
};

fetchServerCameraList = async (serverId, page = 1) => {
  try {
    let token = localStorage.getItem(globalVariables.AUTH_TOKEN);

    // 🔍 First check if server is offline
    const server = this.state.servers.find(s => s.server_id === serverId);
    if (server && !server.is_online) {
      this.setState({
        serverWiseCameras: [],
        showServerOfflineMessage: true,
        showNoCamerasMessage: false,

        // turn off special lists
        showOfflineList: false,
        showInitializingList: false,
        showLowFpsList: false,

        loading: false
      });
      return; // ⛔ STOP here
    }

    // 🔵 Server is ONLINE → fetch camera list
    const res = await fetch(
      urls.GET_SERVER_CAMERA_LIST(serverId, page),
      {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      }
    );

    const data = await res.json();
    const result = data.results;

    const cameras = result.cameras || [];

        if (this.state.selectedCameraCard !== "online") {
      return; 
    }

    // ✔ Safe to update
    this.setState({
      serverWiseCameras: cameras,
      serverWisePage: page,
      serverWiseNext: data.next,
      serverWisePrev: data.previous,
      showServerOfflineMessage: false,
      showNoCamerasMessage: cameras.length === 0,
      showOfflineList: false,
      showInitializingList: false,
      showLowFpsList: false,
      loading: false
    });

  } catch (err) {
    console.error("Failed to fetch server-wise cameras", err);
    this.setState({ loading: false });
  }
};



fetchInitializingCameras = async () => {
  try {
    this.setState({
      initializingLoading: true,
      initializingRecords: [],  
      showInitializingList: true,
      showOfflineList: false,
      showLowFpsList: false,      // ✅ reset FPS view
      serverWiseCameras: [],      // hide server table
      selectedServer: ""          // reset dropdown
    });

    let token = localStorage.getItem(globalVariables.AUTH_TOKEN);

    const res = await fetch(urls.GET_INITIALIZING_CAMERAS, {
      method: "GET",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    const data = await res.json();
    console.log("--fetchInitializingCameras--data", data);
    this.setState({
      initializingRecords: data.cameras || [],
      initializingLoading: false
    });
  } catch (err) {
    console.error("Failed to load initializing cameras", err);
    this.setState({ initializingLoading: false });
  }
};



// fetchServerCameras = async (serverId) => {
//   try {
//     this.setState({ selectedServer: serverId, loading: true });

//     const username = localStorage.getItem(globalVariables.SERVER_CAPACITY_USERNAME);
//     const password = localStorage.getItem(globalVariables.SERVER_CAPACITY_PASSWORD);

//     const response = await fetch(urls.SERVER_CAMERAS(serverId), {
//       method: "GET",
//       headers: {
//         accept: "application/json",
//         Authorization: "Basic " + btoa(`${username}:${password}`)
//       }
//     });

//     if (!response.ok) throw new Error("Failed to fetch server cameras");

//     const data = await response.json();

//     // 📌 STORE ONLY CAMERA IDs FOR FILTERING
//     const deviceIds = new Set(data.cameras.map(cam => cam.device_id));

//     this.setState({
//       serverDeviceIds: deviceIds,
//       loading: false
//     });

//   } catch (err) {
//     console.error("Error fetching server cameras:", err);
//     this.setState({ loading: false });
//   }
// };

fetchLowFpsCameras = async (fps = 6) => {
  try {
    this.setState({
      lowFpsLoading: true,
      showLowFpsList: true,
      showOfflineList: false,
      showInitializingList: false,
      serverWiseCameras: [],
      selectedServer: ""
    });

    let token = localStorage.getItem(globalVariables.AUTH_TOKEN);

    const res = await fetch(urls.GET_LOW_FPS_CAMERA_LIST(fps), {
      method: "GET",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();

    this.setState({
      lowFpsCameras: data.cameras || [],
      lowFpsThreshold: data.threshold,
      lowFpsLoading: false,
    });

  } catch (err) {
    console.error("Failed to load low FPS cameras", err);
    this.setState({ lowFpsLoading: false });
  }
};


// groupCamerasBySiteAndDevice = (cameraList) => {
//   const grouped = {};

//   cameraList.forEach((cam, index) => {

//   cam.index_in_list = index;   // 🔥 ADD THIS LINE

//   if (!grouped[cam.site_id]) grouped[cam.site_id] = {};
//   if (!grouped[cam.site_id][cam.device_id]) grouped[cam.site_id][cam.device_id] = [];
//   grouped[cam.site_id][cam.device_id].push(cam);
// });

//   return grouped;
// };




  fetchServerCapacity = async () => {
  this.setState({ loading: true });
  try {

    const username = localStorage.getItem(globalVariables.SERVER_CAPACITY_USERNAME);
    const password = localStorage.getItem(globalVariables.SERVER_CAPACITY_PASSWORD);

    const headers = {
      "content-type": "application/json",
      Authorization: "Basic " + btoa(`${username}:${password}`)
    };

    const data = await get(urls.SERVER_CAPACITY_DETAILS, headers);
    console.log("--fetchServerCapacity--data", data);

    if (data && data.servers) {
      this.setState({
        total_capacity: data.total_capacity || 0,
        total_used: data.total_used || 0,
        total_available: data.total_available || 0,
        utilization_percent: data.utilization_percent || 0,
        servers: data.servers || [],
        loading: false,
      });
    } else {
      this.setState({ loading: false, servers: [] });
    }
  } catch (error) {
    console.error("Error fetching capacity:", error);
    this.setState({ loading: false, servers: [] });
  }
  };


  fetchDashboardData = async () => {
  try {
    this.setState({ loading: true });

    const username = localStorage.getItem(globalVariables.SERVER_CAPACITY_USERNAME);
    const password = localStorage.getItem(globalVariables.SERVER_CAPACITY_PASSWORD);

    const response = await fetch(urls.SERVER_CAPACITY_DASHBOARD, {
      method: "GET",
      headers: {
        accept: "application/json",
        Authorization: "Basic " + btoa(`${username}:${password}`)
      }
    });

    if (!response.ok) throw new Error("Failed to fetch dashboard data");

    const data = await response.json();
    console.log("--fetchDashboardData--data", data);
    this.setState({
      dashboardData: data,
      loading: false,
    });
  } catch (error) {
    console.error("Dashboard fetch error:", error);
    this.setState({ loading: false });
  }
};


fetchCameraStatus = async () => {
  try {
    this.setState({ statusLoading: true });

    const username = localStorage.getItem(globalVariables.SERVER_CAPACITY_USERNAME);
    const password = localStorage.getItem(globalVariables.SERVER_CAPACITY_PASSWORD);

    const response = await fetch(
      urls.CAMERA_STATUS,
      {
        method: "GET",
        headers: {
          accept: "application/json",
          Authorization: "Basic " + btoa(`${username}:${password}`)
        }
      }
    );

    if (!response.ok) throw new Error("Failed to fetch camera status");

    const data = await response.json();
    console.log("--fetchCameraStatus--data", data);
    this.setState({
      cameraStatusSummary: data.summary,
      onlineIds: data.online_camera_ids || [],
      offlineIds: data.offline_camera_ids || [],
      initializingIds: data.initializing_camera_ids || [],
      statusLoading: false,
    });

  } catch (err) {
    console.error("Camera status error:", err);
    this.setState({ statusLoading: false });
  }
};

//Offline camera List
fetchOfflineCameras = async (page = 1) => {
  try {
    this.setState({
      offlineLoading: true,
      showOfflineList: true,
      showInitializingList: false,
      showLowFpsList: false,      // ✅ reset FPS view
      serverWiseCameras: [],      // hide server table
      selectedServer: ""          // reset dropdown
    });

    let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);

    const response = await fetch(urls.GET_OFFLINE_CAMERAS_24H(page), {
      method: "GET",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${access_token}`,
      },
    });

    const data = await response.json();

    this.setState({
      offlineRecords: data.results?.cameras || [],
      offlineCount: data.count,
      offlinePage: page,
      offlineNext: data.next,        // 🔥 ADD
      offlinePrev: data.previous,   
      offlineLoading: false,
    });

  } catch (err) {
    console.error("Error loading offline camera list", err);
    this.setState({ offlineLoading: false });
  }
};


startSessionTimer() {
  setInterval(() => {
    const loginTime = localStorage.getItem("loginTime");
    if (loginTime) {
      const diff = Date.now() - loginTime;
      const minutes = Math.floor(diff / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      this.setState({
        sessionDuration: `${minutes}m ${seconds}s`,
      });
    }
  }, 1000);
}




toggleServerRow = (index) => {
  this.setState({
    openServerRow: this.state.openServerRow === index ? null : index
  });
};




  handleSubTabChange = async (e, newValue) => {
  this.setState({
    activeSubTab: newValue,
    expandedRow: null,

    // 🔥 IMPORTANT: Reset all special camera list views
    showOfflineList: false,
    showInitializingList: false,
    showLowFpsList: false,

    selectedCameraCard: "online",
    showServerDropdown: true
  });

  if (newValue === 3) {
    // CAMERA TAB SELECTED
    this.fetchCameraStatus();
    this.fetchCameraNames();

    // ⭐ WAIT UNTIL SERVERS ARE LOADED
    const waitServers = () =>
      new Promise(resolve => {
        let interval = setInterval(() => {
          if (this.state.servers.length > 0) {
            clearInterval(interval);
            resolve();
          }
        }, 100);
      });

    await waitServers();

    // ⭐ PICK FIRST ONLINE SERVER OR FIRST IN LIST
    const onlineServer = this.state.servers.find(s => s.is_online);
    const defaultServer = onlineServer
      ? onlineServer.server_id
      : this.state.servers[0].server_id;

    this.setState({ selectedServer: defaultServer });

    // ⭐ NOW FETCH CAMERA LIST
    this.fetchServerCameraList(defaultServer, 1);
  }
};


  handleExpand = (id) => {
    this.setState((prev) => ({
      expandedRow: prev.expandedRow === id ? null : id,
    }));
  };


   fetchUnmutedCamerasCount = async () => {
      try {
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          console.log("--------auth tocken---------", access_tocken);
          let headers = {
              'content-type': 'application/json',
              'Authorization': `Bearer ${access_tocken}`
          }
          // console.log("Fetching data from:", urls.GET_UNMUTED_CAMERAS_COUNT);
          const response = await get(urls.GET_UNMUTED_CAMERAS_COUNT, headers);
          console.log("GET_UNMUTED_CAMERAS_COUNT-----:", response);
  
          if (!response || !response.unmuted_camera_count || response.unmuted_camera_count == null ) {
              console.error("Invalid response format or empty list.");
              this.setState({ unmuted_cameras_count: 0 });
              return;
          }
  
          // this.setState({ device_type_list: response }); // Directly use the array from your response
          this.setState({ unmuted_cameras_count: response.unmuted_camera_count });
          console.log("unmuted_cameras_count", response.unmuted_camera_count);
      } catch (error) {
          console.error("Error in fetchDeviceTypes:", error);
          this.setState({ unmuted_cameras_count: 0 });
      }
    }

  render() {
    const {
      activeSubTab,
      expandedRow,
      loading,
      total_capacity,
      total_used,
      total_available,
      utilization_percent,
      servers,
      users,
      unmuted_cameras_count,
    } = this.state;

    return (
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <Box
          className="capacity-dashboard"
          sx={{
            background: "#191e29",
            minHeight: "100vh",
            ml: { xs: 0, md: 1 },
            px: { xs: 0, sm: 1, md: 2 },
            display: "flex",
            justifyContent: "center",
            minWidth: 0,
            overflowX: "hidden",
            "@media (max-width: 768px)": {
              marginLeft: "15px",
              "& .MuiTableContainer-root, & .capacity-table-scroll": {
                maxWidth: "100%",
                overflowX: "auto",
                overscrollBehaviorX: "contain",
                WebkitOverflowScrolling: "touch",
              },
              "& .MuiTable-root": {
                minWidth: 560,

              },
            },
          }}
        >
        <Box sx={{ px: { xs: 0, sm: 1, md: 2 }, pb: 2, width: "100%", minWidth: 0, color: "#2c3342" }}>
            
              <Box sx={{ px: { xs: 1, sm: 2, md: 3 }, width: "100%", minWidth: 0 }}>
                {/* Subtabs */}
                <Box>
                  <Tabs
                    value={this.state.activeSubTab}
                    onChange={this.handleSubTabChange}
                    textColor="inherit"
                    indicatorColor="primary"
                    display="flex"
                    justifyContent="space-between"
                    sx={{
                      mb: 3,
                      // backgroundColor: "#2c3342",
                      // borderRadius: 2,
                      boxShadow: 1,
                      "& .MuiTab-root": {
                        textTransform: "none",
                        fontWeight: 500,
                        fontSize: "14px",
                      color: "#e4e4e4",  // same blackish tone as Email/WhatInfo/AIEngine
                        fontFamily: "Arial, sans-serif",
                        minHeight: "50px",
                      },
                      "& .Mui-selected": {
                        color: "#ffffff",  // keep same selected color
                        fontWeight: 600,
                      },
                      "& .MuiTabs-indicator": {
                        backgroundColor: "#1976d2", // same blue underline as MUI default
                        height: "2px",
                      },
                      "@media (max-width: 768px)": {
                        "& .MuiTabs-scroller": {
                          overflowX: "auto !important",
                          scrollbarWidth: "thin",
                        },
                        "& .MuiTabs-flexContainer": {
                          width: "max-content",
                        },
                        "& .MuiTab-root": {
                          minWidth: 92,
                          px: 1.5,
                          fontSize: "12px",
                        },
                      },
                    }}
                  >
                    
                    <Tab label="OVERVIEW" />
                    <Tab label="SERVERS" />
                    <Tab label="USERS" />
                    <Tab label="CAMERAS" />
                    
                    
                  </Tabs>
                </Box>
                {/* Refresh Button */}
                <Box
                  sx={{
                    background: "#2c3342",
                    borderBottom: "1px solid #e0e0e0",
                    // mt:3,
                    display: "flex",
                    alignItems: "right",
                    justifyContent: "flex-end",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    pb: 3,
                    // ml: "15px",   // ✅ shifts header slightly right
                    height: { xs: "auto", md: 40 },
                    px: { xs: 1, md: 0 },
                  }}
                >
                  <Button
                    variant="outlined"
                    startIcon={<AutorenewIcon />}
                    onClick={() => {
                    this.fetchServerCapacity();
                    this.fetchUnmutedCamerasCount();
                    this.fetchDashboardData();
                    this.fetchCameraStatus();   // 🔥 This updates Online/Offline/Initializing counts
                    // ⭐ When INITIALIZING tab selected → also refresh list
                      if (this.state.selectedCameraCard === "initializing") {
                        this.fetchInitializingCameras();
                      }

                      // ⭐ When OFFLINE tab selected → refresh offline list
                      if (this.state.selectedCameraCard === "offline") {
                        this.fetchOfflineCameras(1);
                      }

                      // ⭐ When ONLINE tab selected → refresh online server cameras
                      if (this.state.selectedCameraCard === "online") {
                        if (this.state.selectedServer) {
                          this.fetchServerCameraList(this.state.selectedServer, 1);
                        }
                      }
                    }}
                    sx={{height:35}}
                  >
                    Refresh
                  </Button>
                </Box>
                
                {/* ===== SERVER OVERVIEW ===== */}
                {activeSubTab === 0 && (
                  <Box sx={{background: "#2c3342", pb: { xs: 4, md: 12 }}}>
                    
                    {/* Summary cards */}
                  {/* 🔹 Vertical Summary Section */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",     // 👉 horizontal
                    flexWrap: "wrap",         // 👉 goes to next line if screen is small
                    justifyContent: "center",
                    gap: 3,
                    mb: 3,
                    pt: { xs: 3, md: 8 },
                    // ml: "15px",
                  }}
                >
                  {[
                    { label: "Total Assigned License", value: total_capacity, color: "#2287e4", icon: <StorageIcon /> },
                    // { label: "Used", value: total_used, color: "#2e7d32", icon: <TimelineIcon /> },
                    { label: "Used  License", value: unmuted_cameras_count, color: "rgb(13, 186, 196)", icon: <EmergencyRecordingIcon /> },
                    { label: "Available License", value: `${ total_capacity - unmuted_cameras_count }`, color: "#af4aee", icon: <CheckCircleIcon /> },
                    { label: "Utilization %", value: `${utilization_percent}%`, color: "#f9a825", icon: <SpeedIcon /> },
                  ].map((stat, index) => (
                    <Card
                      key={index}
                      sx={{
                        borderRadius: 3,
                        borderLeft: `6px solid ${stat.color}`,
                        alignContent: "center",
                        justifyContent: "center",
                        background: "#3c4456",
                        width: { xs: "100%", sm: 280 }, // Keep desktop card sizing while filling narrow screens
                        maxWidth: { xs: 360, sm: "none" },
                        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                      }}
                    >
                      <CardContent>
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                          <Box display="flex" alignItems="center" gap={1}>
                            <Box sx={{ color: stat.color }}>{stat.icon}</Box>
                            <Typography variant="body1" sx={{ color: "text.secondary" }}>
                              {stat.label}
                            </Typography>
                          </Box>&nbsp;
                          <Typography variant="h6" sx={{ color: stat.color, fontWeight: "bold" }}>
                            {stat.value}
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  ))}
                </Box>

          {/* 📊 Capacity Overview Progress Bar */}
                <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 3, boxShadow: 2, mb: 3, ml: { xs: 0, md: "15px" }, background: "#3c4456", }}>
                  <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                    Capacity Overview
                  </Typography>
                  <Box display="flex" flexDirection={{ xs: "column", sm: "row" }} gap={{ xs: 0.5, sm: 1 }} justifyContent="space-between" mb={1}>
                    <Typography variant="body2">Currently Used: {total_used}</Typography>
                    <Typography variant="body2">Currently Available: {total_available}</Typography>
                  </Box>
                  <LinearProgress
                    variant="determinate"
                    value={utilization_percent}
                    sx={{
                      height: 10,
                      borderRadius: 5,
                      "& .MuiLinearProgress-bar": {
                        background: "linear-gradient(to right, #1976d2, #42a5f5)",
                      },
                    }}
                  />
                  <Typography
                    variant="caption"
                    display="block"
                    textAlign="right"
                    mt={0.5}
                  >
                    {utilization_percent.toFixed(2)}%
                  </Typography>
                </Card>
                  </Box>
                )}

                {/* ===== SERVERS TAB ===== */}
                {activeSubTab === 1 && (
                      <Box
                        sx={{
                          minHeight: "60vh",          // ✔ adjusts to screen sx={{background: "#2c3342"}}
                          maxHeight: "65vh",          // ✔ ensures scroll works on any screen
                          overflowY: "auto",
                          px: { xs: 1, sm: 2, md: 3 },
                          pb: 6,
                          pt: 1,
                          backgroundColor: "#2c3342",
                          "&::-webkit-scrollbar": { width: "6px" },
                          "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#4461bb",
                            borderRadius: "4px",
                          },
                        }}
                      >
                        
                    {servers.length === 0 ? (
                      <Typography variant="body2" color="text.secondary">
                        No server data available.
                      </Typography>
                    ) : (
                      servers.map((server, index) => (
                        <Card
                          key={index}
                          sx={{
                            mb: 1.5,
                            p: 2,
                            borderRadius: "8px",
                            backgroundColor: "#303a4d",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                            border: "1px solid #6a6a6a",
                            width: "100%",
                            maxWidth: 1000,
                            mx: "auto",
                            transition: "all 0.2s ease",
                            "&:hover": {
                              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                              transform: "translateY(-2px)",
                            },
                          }}
                        >
                          {/* Header */}
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{ mb: 1, gap: 1, flexWrap: { xs: "wrap", sm: "nowrap" } }}
                          >
                            <Box display="flex" alignItems="center" gap={1.5}>
                              <Box
                                sx={{
                                backgroundColor: server.is_online ? "#22c55e" : "#f74747ff",
                                color: "#fff",
                                width: 40,
                                height: 40,
                                borderRadius: 2,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                }}
                                >
                              <DnsIcon />
                              </Box>
                              <Box>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ fontWeight: 600, color: "#c4cad2" }}
                                >
                                  {server.server_id || `Server ${index + 1}`}
                                </Typography>
                                <Typography
                                  variant="caption"
                                  sx={{ color: "#c4cad2", fontWeight: 500 }}
                                >
                                  {server.status || "OK"}
                                </Typography>
                              </Box>
                            </Box>

                                    <Box
                                      sx={{
                                        backgroundColor: server.is_online
                                          ? "rgba(209, 250, 229, 0.8)"
                                          : "rgba(254, 226, 226, 0.8)",
                                        color: server.is_online ? "#065f46" : "#991b1b",
                                        px: 1.8,
                                        py: 0.4,
                                        borderRadius: 3,
                                        fontSize: "12px",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {server.is_online ? "Online" : "Offline"}
                                    </Box>
                                  </Box>

                          {/* Current Load */}
                          <Box>
                            <Typography
                              variant="body2"
                              sx={{ color: "#a1a9b9", mb: 0.5, fontWeight: 500 }}
                            >
                              Current Load
                            </Typography>
                            <LinearProgress
                              variant="determinate"
                              value={server.utilization_percent || 0}
                              sx={{
                                height: 8,
                                borderRadius: 5,
                                "& .MuiLinearProgress-bar": {
                                  backgroundColor: server.is_online ? "#22c55e" : "#b91c1c",
                                },
                              }}
                            />
                            <Typography
                              variant="body2"
                              sx={{
                                mt: 0.5,
                                textAlign: "right",
                                fontWeight: 600,
                                color: "#111827",
                              }}
                            >
                              {server.current_load || 0} / {server.max_capacity || 0}
                            </Typography>
                          </Box>

                                  {/* Footer Row */}
                                  <Grid container spacing={2} sx={{ mt: 2 }}>
                                    <Grid item xs={12} sm={4}>
                                      <Typography
                                        variant="caption"
                                        sx={{ color: "#a1a9b9", display: "block" }}
                                      >
                                        Utilization
                                      </Typography>
                                      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                                        {server.utilization_percent
                                          ? `${server.utilization_percent}%`
                                          : "0%"}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                      <Typography
                                        variant="caption"
                                        sx={{ color: "#a1a9b9", display: "block" }}
                                      >
                                        Capacity
                                      </Typography>
                                      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                                        {server.max_capacity || 0}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                      <Typography
                                        variant="caption"
                                        sx={{ color: "#a1a9b9", display: "block" }}
                                      >
                                        Available
                                      </Typography>
                                      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                                      {server.max_capacity && server.current_load
                                            ? server.max_capacity - server.current_load
                                            : 0}                      
                                            </Typography>
                                    </Grid>
                                  </Grid>
                                </Card>
                              ))
                            )}
                          </Box>
                )}

                {/* ===== USERS TAB ===== */}
                {activeSubTab === 2 && (
                  <>
                    {this.state.dashboardData && this.state.dashboardData.users ? (
                      <Box
                        sx={{
                          minHeight: "25vh",
                          px: 1,
                          pb: 5,
                          pt: 1,
                          backgroundColor: "#2c3342",
                        }}
                      >
                        
                        {/* ================= SUMMARY CARDS + FILTER (YOUR ORIGINAL UI) ================= */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: { xs: "stretch", sm: "center" },
                            flexDirection: { xs: "column", sm: "row" },
                            gap: { xs: 1.5, sm: 1 },
                            mb: 2,
                            width: "100%",
                          }}
                        >
                          {/* LEFT — CARDS */}
                          <Box
                            sx={{
                              display: "flex",
                              gap: 1.5,
                              flexWrap: "nowrap",
                              overflowX: "auto",
                              overscrollBehaviorX: "contain",
                              WebkitOverflowScrolling: "touch",
                              paddingBottom: 1,
                              "&::-webkit-scrollbar": { height: "5px" },
                              "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#1976d2",
                                borderRadius: "8px",
                              },
                              maxWidth: { xs: "100%", sm: "85%" },
                            }}
                          >
                            {[
                              {
                                label: "Total Users",
                                value: Object.keys(this.state.dashboardData.users).length,
                                color: "#85c0ff",
                              },
                              {
                                label: "Technician Users",
                                value: Object.values(this.state.dashboardData.users).filter(
                                  (u) => u.user_type === "TechnicianUser"
                                ).length,
                                color: "#8aff53",
                              },
                              {
                                label: "Dealer Users",
                                value: Object.values(this.state.dashboardData.users).filter(
                                  (u) => u.user_type === "DealerUser"
                                ).length,
                                color: "#e7ff5e",
                              },
                              {
                                label: "Customer Users",
                                value: Object.values(this.state.dashboardData.users).filter(
                                  (u) => u.user_type === "CustomerUser"
                                ).length,
                                color: "#e785ff",
                              },
                              {
                                label: "Active Users",
                                value: Object.values(this.state.dashboardData.users).filter(
                                  (u) => u.status === "active"
                                ).length,
                                color: "#a3e8a7",
                              },
                              {
                                label: "Inactive Users",
                                value:
                                  Object.keys(this.state.dashboardData.users).length -
                                  Object.values(this.state.dashboardData.users).filter(
                                    (u) => u.status === "active"
                                  ).length,
                                color: "#ffc72d",
                              },
                              {
                                label: "Activity Rate",
                                value: (() => {
                                  const total =
                                    Object.keys(this.state.dashboardData.users).length;
                                  const active =
                                    Object.values(this.state.dashboardData.users).filter(
                                      (u) => u.status === "active"
                                    ).length;
                                  return total ? Math.round((active / total) * 100) + "%" : "0%";
                                })(),
                                color: "#ffb59a",
                              },
                            ].map((stat, index) => (
                              <Card
                                key={index}
                                sx={{
                                  borderRadius: 2,
                                  border: "1px solid #b0b0b0",
                                  minWidth: 130,
                                  minHeight: 65,
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  textAlign: "center",
                                  backgroundColor: "#3c4456",
                                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                }}
                              >
                                <Typography sx={{ fontSize: "14px", color: "#fff" }}>
                                  {stat.label}
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: "18px",
                                    fontWeight: 700,
                                    color: stat.color,
                                  }}
                                >
                                  {stat.value}
                                </Typography>
                              </Card>
                            ))}
                          </Box>

                          {/* RIGHT — FILTER */}
                          <FormControl size="small" sx={{ minWidth: 130, width: { xs: "100%", sm: "auto" } }}>
                            <InputLabel>Filter</InputLabel>
                            <Select
                              value={this.state.filterDays}
                              label="Filter"
                              onChange={(e) => this.setState({ filterDays: e.target.value })}
                            >
                              <MenuItem value={1}>Last 1 Day</MenuItem>
                              <MenuItem value={7}>Last 7 Days</MenuItem>
                              <MenuItem value={30}>Last 30 Days</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>

                        {/* ================= TWO TABLES SIDE BY SIDE ================= */}
                        <Grid container spacing={2} sx={{ mt: 1, }}>

                          {/* LEFT TABLE */}
                          <Grid item xs={12} md={7}>
                            <Card
                              sx={{
                                borderRadius: 2,
                                border: "1px solid #d0d0d0",
                                // backgroundColor: "#121212",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                overflow: "hidden",
                                
                                height: "45vh",
                              }}
                            >
                              <Box
                                className="capacity-table-scroll"
                                sx={{
                                  flexGrow: 2,
                                  maxHeight: "45vh",
                                  overflow: "auto",
                                  "&::-webkit-scrollbar": { width: "8px" },
                                    "&::-webkit-scrollbar-thumb": {
                                      backgroundColor: "#1976d2",
                                      borderRadius: "8px",
                                    },
                                  // px: 2,
                                  py: 1,
                                }}
                              >
                                <Table stickyHeader>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell sx={{ fontWeight: "bold", backgroundColor: "#222b3f" }}>User</TableCell>
                                      <TableCell sx={{ fontWeight: "bold", backgroundColor: "#222b3f" }}>Type</TableCell>
                                      <TableCell sx={{ fontWeight: "bold", backgroundColor: "#222b3f" }}>Cameras</TableCell>
                                      <TableCell sx={{ fontWeight: "bold", backgroundColor: "#222b3f" }}>Servers</TableCell>
                                      <TableCell sx={{ fontWeight: "bold", backgroundColor: "#222b3f" }}>Detections</TableCell>
                                      <TableCell sx={{ fontWeight: "bold", backgroundColor: "#222b3f" }}>Average Speed</TableCell>
                                      <TableCell sx={{ fontWeight: "bold", backgroundColor: "#222b3f" }}>Session</TableCell>
                                    </TableRow>
                                  </TableHead>

                                  <TableBody>
                                    {Object.values(this.state.dashboardData.users).map(
                                      (user, index) => (
                                        <TableRow key={index} hover>
                                          <TableCell>
                                            <Box display="flex" alignItems="center" gap={2}>
                                              <Box
                                                sx={{
                                                  width: 38,
                                                  height: 38,
                                                  borderRadius: "50%",
                                                  background:
                                                    "linear-gradient(135deg, #6a11cb, #2575fc)",
                                                  color: "#fff",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  fontWeight: "bold",
                                                  fontSize: "14px",
                                                }}
                                              >
                                                {user.username?.slice(0, 2)?.toUpperCase() || "U"}
                                              </Box>

                                              <Box>
                                                <Typography sx={{ fontWeight: 600 }}>
                                                  {user.name || user.username}
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary">
                                                  @{user.username}
                                                </Typography>
                                              </Box>
                                            </Box>
                                          </TableCell>

                                          <TableCell>
                                            <Box
                                              sx={{
                                                px: 1.5,
                                                py: 0.4,
                                                borderRadius: 2,
                                                fontSize: "12px",
                                                backgroundColor:
                                                  user.user_type === "DealerUser"
                                                    ? "rgba(76, 175, 80, 0.15)"
                                                    : user.user_type === "TechnicianUser"
                                                    ? "rgba(33, 150, 243, 0.15)"
                                                    : "rgba(255, 193, 7, 0.15)",
                                                color:
                                                  user.user_type === "DealerUser"
                                                    ? "#41bc47"
                                                    : user.user_type === "TechnicianUser"
                                                    ? "#4da0f2"
                                                    : "#ff9d47",
                                              }}
                                            >
                                              {user.user_type?.replace("User", "") || "User"}
                                            </Box>
                                          </TableCell>

                                          <TableCell>
                                            <Box
                                              sx={{
                                                background: "rgba(33,150,243,0.1)",
                                                color: "#4da0f2",
                                                borderRadius: "50%",
                                                width: 28,
                                                height: 28,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {user.total_cameras || 0}
                                            </Box>
                                          </TableCell>

                                          {/* SERVERS — clickable bubble, toggles inline server ids */}
                                          <TableCell
                                            onClick={() => this.toggleServerRow(index)}
                                            sx={{ cursor: "pointer", userSelect: "none", width: 180 }}
                                          >
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                              <Box
                                                sx={{
                                                  background: "rgba(156, 39, 176, 0.1)",
                                                  color: "#9c27b0",
                                                  borderRadius: "50%",
                                                  width: 28,
                                                  height: 28,
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {user.servers ? Object.keys(user.servers).length : 0}
                                              </Box>

                                              {/* Expanded server ids inline */}
                                              {this.state.openServerRow === index && user.servers && (
                                                <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                                                  {Object.keys(user.servers).map((sid) => (
                                                    <Box
                                                      key={sid}
                                                      sx={{
                                                        background: "rgba(156, 39, 176, 0.15)",
                                                        padding: "3px 8px",
                                                        borderRadius: 1,
                                                        fontSize: "12px",
                                                        color: "#9c27b0",
                                                        fontWeight: 600,
                                                      }}
                                                    >
                                                      {sid}
                                                    </Box>
                                                  ))}
                                                </Box>
                                              )}
                                            </Box>
                                          </TableCell>

                                          <TableCell>{user.detections_per_day || 0}</TableCell>
                                          <TableCell>{user.ack_speed ? `${user.ack_speed} sec` : "-"}</TableCell>
                                          <TableCell>{this.state.sessionDuration}</TableCell>
                                        </TableRow>
                                      )
                                    )}
                                  </TableBody>
                                </Table>
                              </Box>
                            </Card>
                          </Grid>

                          {/* RIGHT TABLE */}
                          <Grid item xs={12} md={5}>
                            <Card
                              sx={{
                                borderRadius: 2,
                                width: "100%",
                                border: "1px solid #d0d0d0",
                                // backgroundColor: "#232323",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                overflow: "hidden",
                                height: "45vh",
                              }}
                            >
                              <Box
                                className="capacity-table-scroll"
                                sx={{
                                  flexGrow: 2,
                                  maxHeight: "45vh",
                                  overflow: "auto",
                                  "&::-webkit-scrollbar": { width: "8px" },
                                    "&::-webkit-scrollbar-thumb": {
                                      backgroundColor: "#1976d2",
                                      borderRadius: "8px",
                                    },
                                  width: "100%",
                                  // px: 2,
                                  py: 1,
                                }}
                              >
                                <Table stickyHeader>
                                  <TableHead sx={{  }}>
                                    <TableRow>
                                      <TableCell sx={{ fontWeight: "bold", backgroundColor: "#222b3f" }}>Email</TableCell>
                                      <TableCell sx={{ fontWeight: "bold", backgroundColor: "#222b3f" }}>Servers</TableCell>
                                      <TableCell sx={{ fontWeight: "bold", backgroundColor: "#222b3f" }}>Engagement</TableCell>
                                    </TableRow>
                                  </TableHead>

                                  <TableBody>
                                    {Object.values(this.state.dashboardData.users).map(
                                      (user, index) => (
                                        <TableRow key={index} hover>
                                          <TableCell>{user.email || "-"}</TableCell>
                                          <TableCell>
                                            {user.servers ? Object.keys(user.servers).length : 0}
                                          </TableCell>
                                          <TableCell>{user.engagement_percent || "0%"}</TableCell>
                                        </TableRow>
                                      )
                                    )}
                                  </TableBody>
                                </Table>
                              </Box>
                            </Card>
                          </Grid>
                        </Grid>
                      </Box>
                    ) : (
                      <Box sx={{ p: 2, textAlign: "center" }}>
                        <Typography variant="body1" color="text.secondary">
                          Loading user data...
                        </Typography>
                      </Box>
                    )}
                  </>
                )}

                {/* ===== CAMERAS TAB ===== */}
                {activeSubTab === 3 && (
                  <Box 
                  sx={{ 
                    minHeight: "25vh", maxHeight: { xs: "none", md: "65vh" }, overflowY: "auto", px: { xs: 1, sm: 2, md: 3 }, pb: 3, pt: 1,
                    backgroundColor: "#2c3342",
                    "&::-webkit-scrollbar": { width: "8px" },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#1976d2",
                      borderRadius: "8px",
                    },
                    }}>
                    
                    {/* ===================== CAMERA STATUS SUMMARY ===================== */}
                    {/* <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                      Camera Distribution
                    </Typography> */}

                {this.state.cameraStatusSummary && (
                  <Box
                    sx={{
                      maxWidth: "100%",     //  LIMIT how wide this row can expand
                      mx: "auto",             // CENTER the whole row nicely
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: 3,
                      px: { xs: 0, sm: 1, md: 2 },
                      mb: 2,
                    }}
                  >

                            {/* ONLINE CARD */}
                    <Card
                        sx={{
                          flex: 1,             // ⬅️ makes card fill space evenly
                          maxWidth: 250,       // ⬅️ optional limit so it looks good
                          minWidth: { xs: 0, sm: 180 },
                          flexBasis: { xs: "100%", sm: 180 },
                          p: 2,
                          textAlign: "center",
                          backgroundColor: "#3c4456",
                          cursor: "pointer",
                          borderRadius: 2,
                          transition: "0.2s",
                          boxShadow: this.state.selectedCameraCard === "online"
                            ? "0 0 12px 3px #3ea13efc"
                            : "none",
                          border: this.state.selectedCameraCard === "online"
                            ? "2px solid #7cfd7c"
                            : "2px solid transparent",
                          // HOVER (disabled when selected)
                          "&:hover": {
                            transform: this.state.selectedCameraCard === "online" 
                              ? "none" 
                              : "translateY(-4px)",
                            boxShadow: this.state.selectedCameraCard === "online"
                              ? "0 0 12px 3px #3ea13efc"
                              : "0 4px 10px rgba(0,0,0,0.2)"
                          }
                          
                        }}
                        onClick={() => {
                          const onlineServer = this.state.servers.find(s => s.is_online);
                          const defaultServer = onlineServer
                            ? onlineServer.server_id
                            : this.state.servers[0]?.server_id;

                          this.setState({
                            selectedCameraCard: "online",
                            showServerDropdown: true,   // 🔥 show dropdown
                            showOfflineList: false,
                            showInitializingList: false,
                            showLowFpsList: false,
                            loading: true,
                            selectedServer: defaultServer
                          });

                          this.fetchServerCameraList(defaultServer, 1);
                        }}
                      >

                      <Typography variant="subtitle2">Online</Typography>
                      <Typography variant="h5" sx={{ fontWeight: 700, color: "#7cfd7c" }}>
                        {this.state.cameraStatusSummary.online}
                      </Typography>
                    </Card>

                    {/* OFFLINE CARD */}
                    <Card
                      sx={{
                        flex: 1,             // ⬅️ makes card fill space evenly
                        maxWidth: 250,       // ⬅️ optional limit so it looks good
                        minWidth: { xs: 0, sm: 180 },
                        flexBasis: { xs: "100%", sm: 180 },
                        p: 2,
                        textAlign: "center",
                        backgroundColor: "#3c4456",
                        cursor: "pointer",
                        borderRadius: 2,
                        transition: "0.2s",

                        // SELECTED STYLE
                        boxShadow: this.state.selectedCameraCard === "offline"
                          ? "0 0 12px 3px rgba(255,0,0,0.5)"
                          : "none",
                        border: this.state.selectedCameraCard === "offline"
                          ? "2px solid red"
                          : "2px solid transparent",

                        // HOVER (disabled when selected)
                        "&:hover": {
                          transform: this.state.selectedCameraCard === "offline" 
                            ? "none" 
                            : "translateY(-4px)",
                          boxShadow: this.state.selectedCameraCard === "offline"
                            ? "0 0 12px 3px rgba(255,0,0,0.5)"
                            : "0 4px 10px rgba(0,0,0,0.2)"
                        }
                      }}
                      onClick={() => {
                        this.setState({
                          selectedCameraCard: "offline",
                          showServerDropdown: false,
                        });
                        this.fetchOfflineCameras(1);
                      }}
                    >

                      <Typography variant="subtitle2">Offline</Typography>
                      <Typography variant="h5" sx={{ fontWeight: 700, color: "red" }}>
                        {this.state.cameraStatusSummary.offline}
                      </Typography>
                    </Card>

                    {/* INITIALIZING CARD */}
                    <Card
                      sx={{
                        flex: 1,             // ⬅️ makes card fill space evenly
                        maxWidth: 250,       // ⬅️ optional limit so it looks good
                        minWidth: { xs: 0, sm: 180 },
                        flexBasis: { xs: "100%", sm: 180 },
                        p: 2,
                        textAlign: "center",
                        backgroundColor: "#3c4456",
                        cursor: "pointer",
                        borderRadius: 2,
                        transition: "0.2s",

                        boxShadow: this.state.selectedCameraCard === "initializing"
                          ? "0 0 12px 3px rgba(255,165,0,0.5)"
                          : "none",
                        border: this.state.selectedCameraCard === "initializing"
                          ? "2px solid orange"
                          : "2px solid transparent",

                        "&:hover": {
                          transform: this.state.selectedCameraCard === "initializing" 
                            ? "none" 
                            : "translateY(-4px)",
                          boxShadow: this.state.selectedCameraCard === "initializing"
                            ? "0 0 12px 3px rgba(255,165,0,0.5)"
                            : "0 4px 10px rgba(0,0,0,0.2)"
                        }
                      }}
                      onClick={() => {
                        this.setState({
                          selectedCameraCard: "initializing",
                          showServerDropdown: false,
                        });
                        this.fetchInitializingCameras();
                      }}
                    >

                        <Typography variant="subtitle2">Initializing</Typography>
                        <Typography variant="h5" sx={{ fontWeight: 700, color: "orange" }}>
                          {this.state.cameraStatusSummary.initializing}
                        </Typography>
                    </Card>

                    {/* LOW FPS CARD */}
                    <Card
                      sx={{
                        flex: 1,             // ⬅️ makes card fill space evenly
                        maxWidth: 250,       // ⬅️ optional limit so it looks good
                        minWidth: { xs: 0, sm: 180 },
                        flexBasis: { xs: "100%", sm: 180 },
                        p: 2,
                        textAlign: "center",
                        backgroundColor: "#3c4456",
                        cursor: "pointer",
                        borderRadius: 2,
                        transition: "0.2s",

                        boxShadow: this.state.selectedCameraCard === "lowfps"
                          ? "0 0 12px 3px rgba(25,118,210,0.5)"
                          : "none",
                        border: this.state.selectedCameraCard === "lowfps"
                          ? "2px solid #1976d2"
                          : "2px solid transparent",

                        "&:hover": {
                          transform: this.state.selectedCameraCard === "lowfps" 
                            ? "none" 
                            : "translateY(-4px)",
                          boxShadow: this.state.selectedCameraCard === "lowfps"
                            ? "0 0 12px 3px rgba(25,118,210,0.5)"
                            : "0 4px 10px rgba(0,0,0,0.2)"
                        }
                      }}
                      onClick={() => {
                        this.setState({
                          selectedCameraCard: "lowfps",
                          showServerDropdown: false,
                        });
                        this.fetchLowFpsCameras(3);
                      }}
                    >

                        <Typography variant="subtitle2">Low FPS</Typography>
                        <Typography variant="h5" sx={{ fontWeight: 700, color: "#1976d2" }}>
                          {this.state.lowFpsCameras.length}
                        </Typography>
                    </Card>
                  </Box>
                )}

                    {/* ===================== SERVER DROPDOWN ===================== */}
                  {/* ===================== PROFESSIONAL SERVER DROPDOWN ===================== */}
                  {this.state.showServerDropdown && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 2,
                      p: 2,
                      background: "#3c4456",
                      borderRadius: 2,
                      boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                      border: "1px solid #e5e7eb",
                      flexWrap: "wrap"
                    }}
                  >

                    <Typography sx={{ fontWeight: 600, fontSize: "15px", color:'#dadada' }}>
                      Select Server:
                    </Typography>

                    <FormControl size="small" sx={{ width: { xs: "100%", sm: 260 } }}>
                      <InputLabel sx={{ fontWeight: 600 }}>Server</InputLabel>

                      <Select
                        value={this.state.selectedServer || ""}
                        label="Server"
                        onChange={(e) => {
                          const id = e.target.value;
                          if (!id) return;

                          const server = this.state.servers.find(s => s.server_id === id);

                          // 🔴 CASE 1: If server is OFFLINE → show offline message, STOP API
                          if (server && !server.is_online) {
                            this.setState({
                              selectedServer: id,
                              serverWiseCameras: [],
                              showServerOfflineMessage: true,
                              showNoCamerasMessage: false,

                              // hide all special lists
                              showOfflineList: false,
                              showInitializingList: false,
                              showLowFpsList: false,
                              loading: false,
                            });
                            return; // ⛔ Do not fetch cameras
                          }

                          // 🟢 CASE 2: Server is ONLINE → load camera list normally
                          this.setState({
                            selectedServer: id,
                            loading: true,
                            showServerOfflineMessage: false,
                            showNoCamerasMessage: false,

                            // turn off special list views
                            showOfflineList: false,
                            showInitializingList: false,
                            showLowFpsList: false,
                          });

                          this.fetchServerCameraList(id, 1);
                        }}
                      >

                        {/* DEFAULT OPTION */}
                        {/* <MenuItem value="">
                          <em>Select Server</em>
                        </MenuItem> */}

                        {/* REAL SERVERS */}
                        {this.state.servers.map((server) => (
                          <MenuItem key={server.server_id} value={server.server_id}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <DnsIcon
                                fontSize="small"
                                sx={{ color: server.is_online ? "#22c55e" : "#ef4444" }}
                              />
                              <Typography>Server {server.server_id}</Typography>
                            </Box>
                          </MenuItem>
                        ))}

                      </Select>
                    </FormControl>
                  </Box>
                )}

                {/* 🔥 SERVER OFFLINE MESSAGE */}
                {this.state.showServerOfflineMessage && (
                  <Box sx={{ mt: 2, textAlign: "center" }}>
                    <Typography sx={{ color: "red", fontWeight: 600 }}>
                      Server is offline — No cameras available.
                    </Typography>
                  </Box>
                )}

                {/* ⚪ NO CAMERAS FOUND MESSAGE */}
                {this.state.showNoCamerasMessage &&
                !this.state.showServerOfflineMessage && (
                  <Box sx={{ mt: 2, textAlign: "center" }}>
                    <Typography sx={{ color: "#dbdbdb", fontWeight: 600 }}>
                      No cameras found for this server.
                    </Typography>
                  </Box>
                )}

                    {/* LOADING SPINNER */}
                    {this.state.loading && (
                      <Box sx={{ textAlign: "center", p: 2 }}>
                        <CircularProgress />
                      </Box>
                    )}
                    
                    {/* ===================== INITIALIZING CAMERA LIST ===================== */}
                {!this.state.showOfflineList &&
                !this.state.showLowFpsList &&           // ⬅️ Added
                this.state.showInitializingList && (
                  <Box>
                    {this.state.initializingLoading ? (
                      <Box sx={{ textAlign: "center", p: 2 }}>
                        <CircularProgress />
                      </Box>
                    ) : (
                      <TableContainer component={Paper} sx={{ borderRadius: 2, maxHeight: "70vh" }}>
                        <Table stickyHeader>
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{backgroundColor: "#222b3f"}}>Site</TableCell>
                              <TableCell sx={{backgroundColor: "#222b3f"}}>Device</TableCell>
                              <TableCell sx={{backgroundColor: "#222b3f"}}>Camera</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {this.state.initializingRecords.map((cam, index) => (
                              <TableRow key={index} hover>
                                <TableCell>{cam.site_name}</TableCell>
                                <TableCell>{cam.device_name}</TableCell>
                                <TableCell>{cam.camera_name}</TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </Box>
                )}


                {/* ===================== OFFLINE CAMERA LIST ===================== */}
                {this.state.showOfflineList &&
                !this.state.showLowFpsList && (
                  <Box>

                    {this.state.offlineLoading ? (
                      <Box sx={{ textAlign: "center", p: 2 }}>
                        <CircularProgress />
                      </Box>
                    ) : (
                      <>
                        <TableContainer
                          component={Paper}
                          sx={{ borderRadius: 2, maxHeight: "70vh" }}
                        >
                          <Table stickyHeader>
                            <TableHead>
                              <TableRow >
                                <TableCell sx={{backgroundColor: "#222b3f"}}>Site</TableCell>
                                <TableCell sx={{backgroundColor: "#222b3f"}}>Device</TableCell>
                                <TableCell sx={{backgroundColor: "#222b3f"}}>Camera</TableCell>
                                <TableCell sx={{backgroundColor: "#222b3f"}}>Offline Duration (hr:mm)</TableCell>
                              </TableRow>
                            </TableHead>

                            <TableBody>
                              {this.state.offlineRecords.map((cam, index) => (
                                <TableRow key={index} hover>
                                  <TableCell>{cam.site_name}</TableCell>
                                  <TableCell>{cam.device_name}</TableCell>
                                  <TableCell>{cam.camera_name}</TableCell>
                                  <TableCell>
                                    <Box
                                      sx={{
                                        px: 1.5,
                                        py: 0.4,
                                        borderRadius: 2,
                                        backgroundColor: "#232323",
                                        color: "red",
                                        fontWeight: 600,
                                        width: '90px'
                                      }}
                                    >
                                      {cam.offline_duration}
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>

                          </Table>
                        </TableContainer>

                        {/* 🔥 Pagination Buttons ONLY for Offline List */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            mt: 2,
                            gap: 1,
                            flexWrap: "wrap",
                          }}
                        >
                          <Button
                            variant="contained"
                            disabled={!this.state.offlinePrev}
                            onClick={() =>
                              this.fetchOfflineCameras(this.state.offlinePage - 1)
                            }
                          >
                            Previous
                          </Button>

                          <Button
                            variant="contained"
                            disabled={!this.state.offlineNext}
                            onClick={() =>
                              this.fetchOfflineCameras(this.state.offlinePage + 1)
                            }
                          >
                            Next
                          </Button>
                        </Box>
                      </>
                    )}

                  </Box>
                )}

                {/* ===================== LOW FPS CAMERA LIST ===================== */}
                {this.state.showLowFpsList && (          
                  <Box>
                    {this.state.lowFpsLoading ? (
                      <Box sx={{ textAlign: "center", p: 2 }}>
                        <CircularProgress />
                      </Box>
                    ) : (
                      <TableContainer component={Paper} sx={{ borderRadius: 2, maxHeight: "70vh" }}>
                        <Table stickyHeader>

                          {/* HEADER */}
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 700, backgroundColor: "#222b3f" }}>Site</TableCell>
                              <TableCell sx={{ fontWeight: 700, backgroundColor: "#222b3f" }}>Device</TableCell>
                              <TableCell sx={{ fontWeight: 700, backgroundColor: "#222b3f" }}>Camera</TableCell>
                              <TableCell sx={{ fontWeight: 700, backgroundColor: "#222b3f" }}>FPS</TableCell>
                              <TableCell sx={{ fontWeight: 700, backgroundColor: "#222b3f" }}>Status</TableCell>
                            </TableRow>
                          </TableHead>

                          {/* BODY */}
                          <TableBody>
                            {this.state.lowFpsCameras.map((cam, index) => (
                              <TableRow key={index} hover>

                                {/* SITE */}
                                <TableCell>{cam.site_name}</TableCell>

                                {/* DEVICE */}
                                <TableCell>{cam.device_name}</TableCell>

                                {/* CAMERA */}
                                <TableCell>{cam.camera_name}</TableCell>

                                {/* FPS */}
                                <TableCell>
                                  <Box
                                    sx={{
                                      px: 1.5,
                                      py: 0.4,
                                      borderRadius: 2,
                                      backgroundColor: cam.fps < 3 ? "#797979" : "#232323",
                                      color: cam.fps < 3 ? "red" : "#1976d2",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {cam.fps.toFixed(2)}
                                  </Box>
                                </TableCell>

                                {/* STATUS */}
                                <TableCell>
                                  <Box
                                    sx={{
                                      px: 1.5,
                                      py: 0.3,
                                      borderRadius: 2,
                                      backgroundColor:
                                        cam.status === "online"
                                          ? "#e8f5e9"
                                          : cam.status === "offline"
                                          ? "#ffebee"
                                          : "#fff8e1",
                                      color:
                                        cam.status === "online"
                                          ? "green"
                                          : cam.status === "offline"
                                          ? "red"
                                          : "orange",
                                      fontWeight: 600,
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    ● {cam.status}
                                  </Box>
                                </TableCell>


                              </TableRow>
                            ))}
                          </TableBody>

                        </Table>
                      </TableContainer>
                    )}
                  </Box>
                )}



                {/* ===================== SERVER-WISE CAMERA LIST ===================== */}
                {this.state.serverWiseCameras &&
                this.state.serverWiseCameras.length > 0 &&
                !this.state.showOfflineList &&
                !this.state.showInitializingList &&
                !this.state.showLowFpsList && (        // ⬅️ LOW FPS hides server-wise table
                  <Box>

                    <TableContainer
                      component={Paper}
                      sx={{ borderRadius: 2, maxHeight: "60vh", mb: 2 }}
                    >
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 700, backgroundColor: "#222b3f" }}>Site</TableCell>
                            <TableCell sx={{ fontWeight: 700, backgroundColor: "#222b3f" }}>Device</TableCell>
                            <TableCell sx={{ fontWeight: 700, backgroundColor: "#222b3f" }}>Camera</TableCell>
                            {/* <TableCell sx={{ fontWeight: 700, backgroundColor: "#222b3f" }}>Status</TableCell> */}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {this.state.serverWiseCameras.map((cam, index) => (
                            <TableRow key={index} hover>
                              <TableCell>{cam.site_name}</TableCell>
                              <TableCell>{cam.device_name}</TableCell>
                              <TableCell>{cam.camera_name}</TableCell>

                              {/* <TableCell>
                                {(() => {
                                  const status = cam.status || "unknown";

                                  let bg = "#e8f5e9";
                                  let color = "green";

                                  if (status === "offline") {
                                    bg = "#ffebee";
                                    color = "red";
                                  } else if (status === "initializing") {
                                    bg = "#fff8e1";
                                    color = "orange";
                                  }

                                  return (
                                    <Box
                                      sx={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        px: 1.5,
                                        py: 0.3,
                                        borderRadius: 2,
                                        backgroundColor: bg,
                                        color: color,
                                        fontWeight: 600,
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      ● {status}
                                    </Box>
                                  );
                                })()}
                              </TableCell> */}

                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>

                    {/* PAGINATION */}
                    <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1, flexWrap: "wrap" }}>
                      <Button
                        variant="contained"
                        disabled={!this.state.serverWisePrev}
                        onClick={() =>
                          this.fetchServerCameraList(
                            this.state.selectedServer,
                            this.state.serverWisePage - 1
                          )
                        }
                      >
                        Previous
                      </Button>

                      <Button
                        variant="contained"
                        disabled={!this.state.serverWiseNext}
                        onClick={() =>
                          this.fetchServerCameraList(
                            this.state.selectedServer,
                            this.state.serverWisePage + 1
                          )
                        }
                      >
                        Next
                      </Button>
                    </Box>

                  </Box>
                )}
                  </Box>
                )}


              </Box>
              </Box>
        </Box>
      </ThemeProvider>
    );
  }
}

export default CapacityDashboard;
